import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Card } from '../components/ui/card';

export default function ProspeccionRevision() {
  return (
    <Card className="p-10 text-center text-ink-400 bg-white border-ink-200">
      <ClipboardList className="w-10 h-10 mx-auto mb-3 text-ink-300" />
      <p className="font-medium text-ink-600">Cola revisión</p>
      <p className="text-sm mt-1">Próximamente — matches pendientes de revisión manual</p>
    </Card>
  );
}
